// extracted by mini-css-extract-plugin
module.exports = {"queues":"SettingsQueues_queues__YgCa2","queueList":"SettingsQueues_queueList__xrVMM"};